import { Container } from "react-bootstrap";
import Publication from "component/shared/publication/Publication";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import MainButton from "component/shared/mainButton/MainButton";

export default function PublicationsTab({ publications }) {
  return (
    <Container
      style={{ backgroundColor: "#EBEBEB", height: "500" }}
      className="whats-new-tab rounded-4 px-4 pb-3 pt-4"
    >
      <div className="row">
        {publications.length > 0 ? (
          publications.map((item, i) => (
            <Publication key={i} item={item} isNew={true} />
          ))
        ) : (
          <DataNotFound />
        )}
      </div>
      <div className="row">
        <label>
          <br />
        </label>
        <div className="col-xl-9 col-md-8 col-sm-6 col-12"></div>
        <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
          <MainButton link={"publications"} text={"all-pubs"} />
        </div>
      </div>
    </Container>
  );
}
